import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Card, Col, Row } from 'antd'
import { observer } from 'mobx-react'
import { slugify } from '../libs/utils.js'

@observer
class Welcome extends Component {

  componentDidMount(){
    
    window.scrollTo(0, 0)
    
    if(window.location.hash.indexOf('#view/') > -1)
      window.location = window.location.hash.replace('#view/', '/doc/')
    
  }

  render(){

    var navs = this.props.store.nav.get_list
 
    if(!navs || navs.length === 0)
      return 'Loading'
    
    navs.map((nav, key) => {
      
      if(nav.name.toLowerCase() === 'spark')
        nav.icon = 'ninja'
      if(nav.name.toLowerCase() === 'swarm')
        nav.icon = 'swarm2'
      if(nav.name.toLowerCase() === 'shift')
        nav.icon = 'shifter'
      if(nav.name.toLowerCase() === 'api')
        nav.icon = 'code'
      if(nav.name.toLowerCase() === 'hardware')
        nav.icon = 'boca'
      if(nav.name.toLowerCase() === 'how to')
        nav.icon = 'howtowand'
        
      return nav
      
    })
    
    return (

      <div className="welcome">
        <p className='lead text-center'>Welcome to the HoldMyTicket documentation.  You will find helpful guides and instructions to all things related to HoldMyTicket.<br /><br />If you have any questions drop us a line at <a href="mailto:support@holdmyticket.com">support@holdmyticket.com</a>.</p>
        <br />
        <Row gutter={16}>
          {navs.map((item, k1) => {
            return (
              
                <Col key={k1} span={8}>
                  
                  <h3 style={{padding: 10}}><i style={{float: 'left', margin: '0 15px 0 0', style: 'block', color: '#222', fontSize: 35}} className={"fi fi-"+item.icon}></i> {item.name}</h3>
                  
                  <Card style={{margin: 10, overflow: 'none'}} className="spot1" bordered={true}>
                    
                    {item.children.map((child, k2) => {

                      return (
                        <Link to={slugify(item.lower) + '/' + slugify(child.lower)} key={k2}>
                          <div className="DocumentChildItem">{child.name}</div>
                        </Link>
                      )
                      
                    })}
                    
                  </Card>
                </Col>
              
            )
          })}
        </Row>
      </div>
      
    )
    
  }
  
}

export default Welcome


// WEBPACK FOOTER //
// ./src/components/Welcome.js